
const slider = document.querySelector('.slider')
const addBackdrop = () => {
  // filtre sur le body dans la partie Apprendre
  if (slider) {
    const header = document.querySelector('.header')
    const body = document.querySelector('body')
    body.classList.add('backdrop')
    header.classList.add('btn--hidden')
  }
}

export {
  slider,
  addBackdrop
}
